import { useMemo } from 'react';
import { usePersonaCollection } from '@sdk/personaCollection/PersonaCollectionContext';
import { mapPersonaToPickerOption } from '@sdk/components/forms/personaPickers/GroupedPersonaPicker/groupedPersonaPicker.utils';

import { MembersField } from '@web/conversations/types/ConversationFields';

export const useRestrictedToUsersField = (members: MembersField) => {
  const { users } = usePersonaCollection();
  const options = useMemo(() => {
    const memberIds = members.value.map((m) => m.id);
    return users
      .filter(
        (u) =>
          u.isActive &&
          (memberIds.includes(u.id) || u.allTypeGroupIds.some((id) => memberIds.includes(id)))
      )
      .map(mapPersonaToPickerOption);
  }, [users, members]);

  return { options };
};
